import { Builder } from '@builder.io/react';

import Feature from './index';
import { iconList } from './iconList';

const defaultFeatureInputs = [
  {
    name: 'cols',
    type: 'number',
    helperText: 'Number of columns to order'
  },
  {
    name: 'spacing',
    type: 'string',
    defaultValue: 'lg',
    enum: ['sm', 'md', 'lg', 'xl']
  }
];

Builder.registerComponent(Feature, {
  name: 'FeatureWithIcon',
  inputs: [
    {
      name: 'features',
      type: 'list',
      defaultValue: [
        {
          title: 'Title'
        }
      ],
      subFields: [
        {
          name: 'icon',
          type: 'string',
          enum: iconList
        },
        {
          name: 'title',
          type: 'string',
          required: true
        },
        {
          name: 'text',
          type: 'richText'
        },
        {
          name: 'link',
          type: 'object',
          subFields: [
            {
              name: 'text',
              type: 'string'
            },
            {
              name: 'href',
              type: 'url'
            },
            { name: 'openInNewTab', type: 'boolean', defaultValue: false }
          ]
        },
        {
          name: 'checklist',
          type: 'list',
          defaultValue: [
            {
              item: 'first checklist item'
            }
          ],
          subFields: [
            {
              name: 'item',
              type: 'string'
            }
          ]
        }
      ]
    },
    ...defaultFeatureInputs
  ]
});

Builder.registerComponent(Feature, {
  name: 'FeatureWithImage',
  inputs: [
    {
      name: 'features',
      type: 'list',
      defaultValue: [
        {
          title: 'Title'
        }
      ],
      subFields: [
        {
          name: 'img',
          type: 'object',
          subFields: [
            {
              name: 'url',
              type: 'file',
              allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg']
            },
            {
              name: 'alt',
              type: 'string'
            },
            {
              name: 'width',
              type: 'number'
            },
            {
              name: 'height',
              type: 'number'
            },
            {
              name: 'borderRadius',
              type: 'boolean'
            }
          ]
        },
        {
          name: 'title',
          type: 'string',
          required: true
        },
        {
          name: 'text',
          type: 'richText'
        },
        {
          name: 'link',
          type: 'object',
          subFields: [
            {
              name: 'text',
              type: 'string'
            },
            {
              name: 'href',
              type: 'url'
            },
            { name: 'openInNewTab', type: 'boolean', defaultValue: false }
          ]
        },
        {
          name: 'checklist',
          type: 'list',
          defaultValue: [
            {
              item: 'first checklist item'
            }
          ],
          subFields: [
            {
              name: 'item',
              type: 'string'
            }
          ]
        }
      ]
    },
    ...defaultFeatureInputs
  ]
});

Builder.registerComponent(Feature, {
  name: 'FeatureWithSlider',
  inputs: [
    {
      name: 'features',
      type: 'list',
      defaultValue: [
        {
          title: 'Title'
        }
      ],
      subFields: [
        {
          name: 'slider',
          type: 'object',
          subFields: [
            {
              name: 'slides',
              type: 'list',
              subFields: [
                { name: 'src', type: 'file', allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'] },
                { name: 'width', type: 'string' },
                { name: 'height', type: 'string' },
                { name: 'alt', type: 'string' }
              ]
            }
          ]
        },
        {
          name: 'title',
          type: 'string',
          required: true
        },
        {
          name: 'text',
          type: 'richText'
        },
        {
          name: 'link',
          type: 'object',
          subFields: [
            {
              name: 'text',
              type: 'string'
            },
            {
              name: 'href',
              type: 'url'
            },
            { name: 'openInNewTab', type: 'boolean', defaultValue: false }
          ]
        },
        {
          name: 'checklist',
          type: 'list',
          defaultValue: [
            {
              item: 'first checklist item'
            }
          ],
          subFields: [
            {
              name: 'item',
              type: 'string'
            }
          ]
        }
      ]
    },
    ...defaultFeatureInputs
  ]
});
